import { render, staticRenderFns } from "./FormWithSteps.vue?vue&type=template&id=a2347018"
import script from "./FormWithSteps.vue?vue&type=script&lang=js"
export * from "./FormWithSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports